import { SiteIdOverrideConfig } from "stores/wizard/config";
import { timeValues24HoursFormat } from "src/components/shared/TimeDropdown/config/time/timeValues";

export const siteId70927: SiteIdOverrideConfig = {
  package: {
    showAllSubLOB: false,
  },
  car: {
    location: {
      destination: {
        inputName: "returnName",
      },
      origin: {
        inputName: "pickupName",
      },
    },
    date: {
      queryParam: {
        start: "",
        end: "",
      },
    },
    form: {
      action: "https://car-rental.expedia.co.in/{locale}-in/book#/vehicles",
    },
    timeValues: timeValues24HoursFormat,
    defaultShowingTime: "10:30",
    isCarTrawler: true,
    showVendorOptions: false,
    clientID: 388196,
    residenceID: "IN",
    includeGT: false,
  },
  lx: {
    form: {
      action: "https://www.expedia.com.sg/things-to-do/search",
    },
  },
  hotel: {
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/IN.HPR.012021.pdf",
  },
};
